import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class UsersTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'roleNames',
        title: 'Роль',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'organizationName',
        title: 'Учреждение / Структурное подразделение',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'position',
        title: 'Должность',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'fio',
        title: 'ФИО',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'email',
        title: 'Электронная почта',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'phone',
        title: 'Телефон',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'userName',
        title: 'Логин',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'password',
        title: 'Пароль',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
    ];
  }


}
